import { FormattedMessage } from 'react-intl';

import ArrowLeftIcon from '@/assets/icons/arrow-sm-left.svg';
import { Button } from '@/components/ui/button';
import { useJobPostingContext } from '@/contexts/job-posting-context';
import { useSafeBackNavigation } from '@/hooks/use-safe-back-navigation';

import { getPreviousStep } from './header/step-config';

export function BackButton() {
  const safeGoBack = useSafeBackNavigation();
  const { currentStep, setCurrentStep, selectedChannelSlugs } =
    useJobPostingContext();

  const handleBackClick = () => {
    const previousStep = getPreviousStep(currentStep, selectedChannelSlugs);

    if (previousStep) {
      setCurrentStep(previousStep);
    } else {
      safeGoBack();
    }
  };

  return (
    <Button
      type="button"
      variant="ghost"
      onClick={handleBackClick}
      className="self-start"
    >
      <img src={ArrowLeftIcon} alt="Back" />
      <FormattedMessage defaultMessage="Back" description="Back button" />
    </Button>
  );
}
